import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "oauth/v2/authorize",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
